<template>
  <div>
    <header-bar>
      スプリット
    </header-bar>
    <div
      class="page-block page-feature">
      <div class="page-block__inner">
        <div>
          <strong>スプリットへの招待を承認しました。</strong><br>
          <br>
          当リリースに関わるすべてのゲストが承認するまで、<br>
          スプリットの設定は保留されます。
        </div>
        <div class="list-container">
          <ul>
            <li>すべてのゲストが承認した場合、スプリットの開始をお知らせします</li>
            <li>
              いずれかのゲストがキャンセルすると、スプリットは開始されません。<br>
              その場合、スプリットがキャンセルされた旨をメールにてお知らせします。
            </li>
          </ul>
        </div>
        <router-link
          :to="{name: 'index'}"
          class="c-btn">
          トップへ
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'

export default {
  name: 'ApprovalComplete',
  components: {
    HeaderBar,
  },
}
</script>

<style scoped>
.page-feature {
  height: 600px;
}

.page-block__inner {
  text-align: center;
  font-weight: 400;
}

.page-block div {
  padding: 10px 30px;
}

.page-block ul, .page-block li {
  list-style: unset !important;
}
.list-container{
  width: fit-content;
  text-align: start;
  margin: auto;
  padding: 14px 0;
}
</style>
